export const form = {
  position: 'sticky',
  top: 110,
}

export const header = {
  position: 'sticky',
  top: 70,
}

export const link = {
  color: 'black',
}

export const rugCardsSegment = {
  padding: 30,
}
